import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../../main/detail/Detail";
import {
  rsActiveMenu,
  rsProgress,
  rsParentCom,
} from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingLinkGrid } from "./UseLandingLinkGrid";
import LandingLinkGridInformation from "./LandingLinkGridInformation";
import LandingLinkGridItems from "./LandingLinkGridItems";

export default function LandingLinkGrid(props) {
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetLandingLinkGrid, deleteLandingLinkGridItem } =
    UseLandingLinkGrid();
  const [model, setModel] = useState();
  const [item, setItems] = useState();

  useEffect(() => {
    if (location.state && location.state.categoryID) {
      setProgress(true);
      GetLandingLinkGrid(location.state.categoryID, (callback) => {
        setItems(callback.items);
        setModel(callback[0]);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/landingmanagment/landingComponents/linkGrid",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            فریم نمایش
          </Typography>
          <LandingLinkGridInformation
            model={model}
            aid={location.state.categoryID}
            callback={() => {
              GetLandingLinkGrid(model.aid, (callback) => {
                setItems(callback.items);
                setModel(callback[0]);
              });
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            آیتم ها
          </Typography>
          <LandingLinkGridItems
            categoryID={model && model.aid}
            itemID={model && model.id}
            items={model && model.items}
            callback={() => {
              GetLandingLinkGrid(model.aid, (callback) => {
                setItems(callback.items);
                setModel(callback[0]);
              });
            }}
          />
        </Box>
      </Box>
    </Detail>
  );
}
